const dev = {
  baseURL: "http://localhost:8053",
};

const prod = {
  baseURL: "https://api.cima.ma",
};

const config = process.env.NODE_ENV === "production" ? prod : dev;

export default config;